
import { Divider, Stack, Typography } from "@mui/material";
import SectionTabs from "../SectionTabs";
import CompositionHeader from "../CompositionHeader";
import { PatientCard, PractitionerCard, OrganizationSection, HospitalBanner } from "../InfoCards";
import EncounterSection from "../EncounterSection";
import DocumentReferenceSection from "../DocumentReferenceSection";
import { labelSx } from "../styles";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HealthDocumentView = ({ bundle, setShowPdfPreview }: { bundle: any; setShowPdfPreview: (v: boolean) => void }) => {
    const composition = bundle?.composition || {};
    const patient = bundle || {};
    const sections = [
        {
            id: "document",
            label: "Document",
            content: bundle?.documentReference || bundle?.binary?.data ? (
                <DocumentReferenceSection
                    documentReference={bundle?.documentReference}
                    binary={bundle?.binary}
                    onPreviewBase64={() => setShowPdfPreview(true)}
                />
            ) : (
                <Typography sx={labelSx}>No document available.</Typography>
            )
        }
    ];

    return (
        <Stack spacing={3}>
            <HospitalBanner organization={bundle?.organization} />
            <CompositionHeader composition={composition} />

            <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ mt: "8px !important" }}>
                <PatientCard patient={patient} />
                <PractitionerCard practitioner={patient} />
            </Stack>

            <OrganizationSection organization={bundle?.organization} />
            <EncounterSection encounter={bundle?.encounter} />

            <Divider />
            <SectionTabs sections={sections} initialId="document" />
        </Stack>
    );
};

export default HealthDocumentView;
